import React from 'react'
import { motion } from 'framer-motion'

const getStrength = (password) => {
  if (!password) return { score: 0, label: '', color: '' }

  let score = 0
  if (password.length >= 6) score++
  if (password.length >= 10) score++
  if (/[A-Z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  if (/[^A-Za-z0-9]/.test(password)) score++

  if (score <= 1) return { score: 1, label: 'Weak', color: 'bg-red-400 dark:bg-red-500' }
  if (score <= 2) return { score: 2, label: 'Fair', color: 'bg-amber-400 dark:bg-amber-500' }
  if (score <= 3) return { score: 3, label: 'Good', color: 'bg-primary-400 dark:bg-primary-500' }
  return { score: 4, label: 'Strong', color: 'bg-green-500 dark:bg-green-500' }
}

export default function PasswordStrength({ password }) {
  const { score, label, color } = getStrength(password)

  if (!password) return null

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.2 }}
      className="mt-2 space-y-1.5"
    >
      <div className="flex gap-1.5">
        {[1, 2, 3, 4].map(i => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-all duration-300 ${
              i <= score ? color : 'bg-surface-200 dark:bg-surface-200'
            }`}
          />
        ))}
      </div>
      <p className={`text-xs font-medium transition-colors duration-200 ${
        score <= 1 ? 'text-red-500' :
        score <= 2 ? 'text-amber-500' :
        score <= 3 ? 'text-primary-600 dark:text-primary-500' :
        'text-green-600 dark:text-green-500'
      }`}>
        {label}
      </p>
    </motion.div>
  )
}
